/* global customElements */
import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';

/**
 * Wrap in a div to avoid layout issue ...see tractors
 * @type type
 */
class TagField extends BaseComponent {
	
	static get properties() {
		return {	
			value: {type: Array},		
			disabled: {type: Boolean},
			required: {type: Boolean},
			fieldClass: {type: String},
			helpText: {type: String},
			style: {type: String},
			name: {type: String},
			label: {type: String},
			maxLength: {type: Number}
		};
	}
	
	constructor() {
		super();	
		
		this.theme = '';
		this.disabled = false;
		this.required = false;
		this.fieldClass = '';
		this.helpText = 'Press Enter to create Tag';
		this.style = 'width: 100%;';
		this.name = '';
		this.label = '';
		this.maxLength = 4096;
				
		var tagField = this;
		setTimeout(function(){
			tagField.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>
		`;
	}
	
	init() {
		var tagField = this;
		
		tagField.tags = [];
				
		var textFieldConfig = {
			tag: 'vaadin-custom-field',			
			name: tagField.name,
			label: tagField.label,
			style: tagField.style,			
			maxLength: tagField.maxLength,
			'helper-text': tagField.helpText,
			listeners: {
				keypress: function(e) {
					if (e.key === 'Enter') {
						if (e.target.value && e.target.value !== '') {
							actionAddTag(e.target.value);
						}						
					}
				}
			},
			children: [
				{
					tag: 'vaadin-text-field',
					itemid: 'textfield',
					style: tagField.style,	
					'class': tagField.fieldClass
				}
			]
		};
		
		if (tagField.disabled) {
			textFieldConfig.disabled = true;
		}
		
		if (tagField.required) {
			textFieldConfig.required = true;
		}		
		
		var textField = ElementUtil.create(textFieldConfig);		
		
		tagField.tagsDiv = ElementUtil.create({
			tag: 'div',
			style: 'padding:3px;'
		});		
		tagField.append(textField);
		tagField.append(tagField.tagsDiv);
		
		var actionAddTag = function(text) {			
			ElementUtil.query(tagField, 'textfield').value = '';
			tagField.tags.push(text);
			tagField.updateTags();			
		};
		
	}	
	
	updateTags() {
		var tagField = this;
		
		ElementUtil.removeAllChildren(tagField.tagsDiv);
		
		tagField.tags.forEach(function(tag){
			var tagBox = ElementUtil.create({
				tag: 'span',
				'class': 'tag-badge',
				style: 'margin: 3px; color: white;',
				children:[
					{
						tag: 'span',
						style: 'margin-right: 5px; ',
						innerHTML: tag
					},
					{
						tag: 'button',
						title: 'remove',
						trustedInnerHTML: true,
						innerHTML: '<b> X</b>',
						listeners: {
							click: function() {
								actionRemove(tag);
							}
						}
					}
				]
				
			});
			tagField.tagsDiv.append(tagBox);
		});
						
		var actionRemove = function(text) {
			var keepTags = [];
			tagField.tags.forEach(function(tag){
				if (tag !== text) {
					keepTags.push(tag);
				}
			});
			tagField.tags = keepTags;
			tagField.updateTags();	
		};
	}
	
	setCustomValue(newValue) {
		var tagField = this;
		//fix timing issue on the form load since it may not be render before this call
		setTimeout(function(){			
			if (Array.isArray(newValue)) {
				tagField.tags = newValue;
			} else {
				tagField.tags = newValue.split(',');
			}
			tagField.updateTags();
		}, 100);
	}
	
	getCustomValue() {
		var tagField = this;
		return tagField.tags;		
	}
	
};
customElements.define('dl-tagfield', TagField);

